module.exports = __webpack_public_path__ + "img/tick.7ad964d6.svg";